import { render, staticRenderFns } from "./compSerial.vue?vue&type=template&id=93f87dfe"
import script from "./compSerial.vue?vue&type=script&lang=js"
export * from "./compSerial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports